module.exports = __webpack_public_path__ + "img/embed.93255d75.png";